<div class="mat-container">
  <div mat-dialog-title> </div>
  <div mat-dialog-content style="text-align: center;">
    <!-- <mat-form-field class="example-full-width" appearance="fill">
        <mat-label>Custom Field Name</mat-label>
        <input matInput placeholder="Enter field name" [(ngModel)]="data.field">
      </mat-form-field> -->
  </div>
  <div style="margin-bottom: 20px;">
    <h4 style="display:table;margin:10px auto">Please select a custom field:</h4>
    <ng-select [items]="cities" bindLabel="name" bindValue="id" (change)="onOptionSelected($event)">
    </ng-select>
  </div>
  <p *ngIf="errMsg" style="font-size: small;color: red;">*{{errMsg}}</p>
  <div mat-dialog-actions class="buttons">
    <button mat-flat-button mat-dialog-close>Close</button>
    <button type="button" mat-flat-button color="primary" [disabled]="!data.field.length"
      (click)="addUpdateField()">Save</button>
  </div>
</div>